module.exports = __webpack_public_path__ + "static/media/tenth_southside_school4.8cc71def.jpg";